import React, { useEffect } from "react";
import ONClauseGenerator from "../../components/ONClauseGenerator.js";
import { createTheme } from "@mui/material/styles";

export default function ClauseGenerator({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  useEffect(() => {
    setProvince("ON");
  }, [setProvince]);

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <ONClauseGenerator
        APS="100"
        ListingType="MLS"
        SellerRep="No"
        BuyerRep="Client"
        theme={theme}
        protectiveToneOptions={[
          "Buyer Protective",
          "Seller Protective",
          "Landlord Protective",
          "Tenant Protective",
        ]}
      />
    </div>
  );
}
